var _objectSpread = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");

var _require = require('../primitives'),
    NUMBER = _require.NUMBER;

var float = _objectSpread({}, NUMBER, {
  type: function type(val) {
    return Number(val) === val && val % 1 !== 0;
  }
});

module.exports = float;